import { Schema } from "effect";
import { AppContextSchema } from "./app-context";
import { ThreadIdSchema } from "./ids";
import { PapersFlowBoundaryParseOptions } from "./standard";

export const PublicErrorCodeSchema = Schema.Literals([
  "UNAUTHENTICATED",
  "FORBIDDEN",
  "NOT_FOUND",
  "INVALID_INPUT",
  "APPROVAL_REQUIRED",
  "RATE_LIMITED",
  "CONNECTION_REQUIRED",
  "PROVIDER_UNAVAILABLE",
  "INTERNAL",
]);

export const ApiErrorSchema = Schema.Struct({
  code: PublicErrorCodeSchema,
  message: Schema.String.check(
    Schema.isMinLength(1),
    Schema.isMaxLength(1_000),
    Schema.makeFilter((value) => value.trim().length > 0 || "messages must not be blank"),
  ),
  requestId: Schema.String.check(
    Schema.isMinLength(1),
    Schema.isMaxLength(160),
    Schema.makeFilter((value) => value.trim().length > 0 || "request IDs must not be blank"),
    Schema.makeFilter(
      (value) => value === value.trim() || "request IDs must not contain surrounding whitespace",
    ),
  ),
  retryable: Schema.Boolean,
  details: Schema.optionalKey(Schema.JsonObject),
});

const { threadId: _threadId, ...ChatAppContextFields } = AppContextSchema.fields;
export const ChatAppContextSchema = Schema.Struct(ChatAppContextFields);

export const ChatRequestSchema = Schema.Struct({
  threadId: ThreadIdSchema,
  messages: Schema.Array(Schema.Json).check(Schema.isMaxLength(500)),
  appContext: ChatAppContextSchema,
  branch: Schema.optionalKey(
    Schema.Struct({
      operation: Schema.Literals(["edit", "resend", "regenerate"]),
      sourceMessageId: Schema.Trim.check(Schema.isMinLength(1), Schema.isMaxLength(180)),
    }),
  ),
});

export const ApprovalDecisionSchema = Schema.Struct({
  approvalId: Schema.Trim.check(Schema.isMinLength(1), Schema.isMaxLength(160)),
  decision: Schema.Literals(["approve", "reject"]),
  reason: Schema.optionalKey(Schema.String.check(Schema.isMaxLength(2_000))),
});

export const decodeApiError = Schema.decodeUnknownSync(
  ApiErrorSchema,
  PapersFlowBoundaryParseOptions,
);
export const decodeChatRequest = Schema.decodeUnknownSync(
  ChatRequestSchema,
  PapersFlowBoundaryParseOptions,
);
export const decodeApprovalDecision = Schema.decodeUnknownSync(
  ApprovalDecisionSchema,
  PapersFlowBoundaryParseOptions,
);

export type PublicErrorCode = typeof PublicErrorCodeSchema.Type;
export type ApiError = typeof ApiErrorSchema.Type;
export type ApiErrorEncoded = typeof ApiErrorSchema.Encoded;
export type ChatRequest = typeof ChatRequestSchema.Type;
export type ChatRequestEncoded = typeof ChatRequestSchema.Encoded;
export type ApprovalDecision = typeof ApprovalDecisionSchema.Type;
export type ApprovalDecisionEncoded = typeof ApprovalDecisionSchema.Encoded;
